import styled from 'styled-components';

import { fontSizes, colors } from 'ui/theme';

const NoDisplay = styled.span`
  color: ${colors.textDisabled};
  font-size: ${fontSizes.s14};
`;

const DisplayLabel = styled.span`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s14};
`;

interface EventHistoryUserAgentLabelProps {
  userAgent: string;
}

export const UserAgentLabel = ({ userAgent }: EventHistoryUserAgentLabelProps) => (
  <>
    {userAgent !== 'undefined' ? (
      <DisplayLabel data-test={`user-agent-label`}>{userAgent}</DisplayLabel>
    ) : (
      <NoDisplay data-test="user-agent-no-display">Undefined</NoDisplay>
    )}
  </>
);
